module.exports = __webpack_public_path__ + "img/img_career_chloe_wong_L@2x.02cfd9bb.png";